import React from "react";
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import UseForm from "./UseForm";
import {validator} from "./Validator";
import {BootstrapDialog} from "../FormComopents/Form/CustomDialog"
import {bgColors} from "../utils/bgColor";
import UseWindowDimensions from '../screensizecontainer/windowdimensions';
import AuthFormHeader from "./AuthFormHeader"
import { DialogActions, DialogContent} from "@mui/material";
// import { STATE_SIGNUP} from "./PostData";
// import Registeruser from "./Services/Registeruser"
import Resetpasswordlink from "./Services/Resetpasswordlink";
const ResetPasswordRequest = (props)=> {
  // const baseURL = postrootpath
  const {openResetPasswordReq}= props
    const {height, width} = UseWindowDimensions()
    const initState = {
      // user_name:"",
      // first_name:"",
      // last_name:"",
      // organization_name:"",
      // phone_no:"",
      // email_id:"",
      emailphone:"",
      // password: "",
      // confirmpassword: "",
    };

      const submit = () => {
        return ("Submited")
      };

      const {
        handleChange,
        handleSubmit,
        handleBlur,
        state,
        errors,
        countryCode
      } = UseForm({
        initState,
        callback: submit,
        validator
      });

      let isValidForm =
        Object.values(errors).filter(error => typeof error !== "undefined")
      .length === 0;

    
    // let _error = []
    // let _result = []
    const submitResetpasssword = (e) => {
      e.preventDefault()
      Resetpasswordlink(state)
    }


  return (
    <Box sx = {{height:height, width:width, borderRadius:10}}>    
    <BootstrapDialog
    // onClose={() => dispatch(closeUserFolio)}
    aria-labelledby="customized-dialog-title"
    // open={openUserFolio}
    open={openResetPasswordReq}

    scroll="paper"
    sx={{
        "& .MuiDialog-container": {
           alignItems: "flex-start",
           "& .MuiPaper-root": {
                  width: "100%",
                  minHeight:"200px",
                  // marginTop:'0.25rem',
                  // marginLeft:'0.5rem',
                  maxWidth: '300px'  // Set your width here
              
                },
        },
     }}
    
    PaperProps={{
       style:{borderRadius: 10,
       background:bgColors.default_backgroun_grey
    }}}
    >
      <AuthFormHeader/>
      <DialogContent 
       sx={{ 
        maxHeight: '100%', 
        maxWidth: 300, padding:'1rem', 
        background:bgColors.grey_100
        }} 
      >
        <form onSubmit={handleSubmit}>
        <Grid container spacing={2} display={"flex"} direction={"column"}>
            <Grid item>
            <TextField
                required
                fullWidth
                size = 'small'
                label="Email /Phone no"
                name="emailphone"
                //   className={margin}
                defaultValue={state.emailphone}
                onChange={handleChange}
                error={errors.emailphone ? true : false}
                helperText={errors.emailphone}
                onBlur={handleBlur}
            />
            </Grid>
        </Grid>
        </form>
    </DialogContent>

    <DialogActions>
    <Grid container spacing={2} display={"flex"} direction={"column"}>
    <Grid item>
          <Button
            fullWidth
            size= 'small'
            disabled={!isValidForm}
            type="submit"
            variant="contained"
            color="primary"
            onClick={submitResetpasssword}
          //   className={margin}
          >
          get link to reset-password
        </Button>
        </Grid>
       <Grid container display={'flex'} spacing={1} direction={'column'}
       justifyContent={'center'} alignItems={'center'} padding={'2'}
       >

      </Grid>
      </Grid>
    </DialogActions>
    </BootstrapDialog>
</Box>

)}
export default ResetPasswordRequest
